<template>
  <div>
    <div class="table" v-for="(item, index) in chartData" :key="item.name">
      <div class="head">{{ item.name }}</div>
      <div class="item">{{ trend(index)[0] }}</div>
      <div class="chart">
        <LevelChart :chartData="item" :split="4" />
      </div>
      <div class="item">{{ trend(index)[1] }}</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.table {
  margin-top: $spacing-ex-small;
  color: $instruction-color;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div.item,
  & > div.head {
    width: 70px;
    padding: 0 $spacing-small;
  }
  & > div.item:nth-child(2) {
    text-align: right;
  }
  .chart {
    flex: 1;
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import LevelChart from "../atoms/LevelChart.vue";
export const CulturalFitTrendMap = [
  ["支援型", "自律型"],
  ["保守", "革新"],
  ["指示命令", "権限移譲"],
  ["年功序列", "成果主義"],
  ["アットホーム", "ドライ"]
];
@Options({
  components: {
    LevelChart
  }
})
export default class CulturalFitChart extends Vue {
  @Prop({ type: Array }) chartData!: { name: string; value: number }[];
  trend(index: number) {
    return CulturalFitTrendMap[index];
  }
}
</script>
